/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 4/17/13
 * Time: 10:39 AM
 * To change this template use File | Settings | File Templates.
 */

/*
 A BaseFilteredAppRouter class which extends the Marionette.AppRouter to support filtering and handlers before and after route
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");

    var BaseFilteredAppRouter = Marionette.AppRouter.extend({
        before: {},

        after: {},

        /**
         * Run set of filters and stops if any of them failing (returns false)
         * @param filters
         * @param fragment
         * @param args
         * @param {boolean} stopOnError - will stop iterating over filters if any returns false
         * @return {boolean}
         * @private
         */
        _filterRoute: function (filters, fragment, args, stopOnError) {
            return _[stopOnError ? "every" : "each"](filters, function (fn, filter) {
                filter = _.isRegExp(filter) ? filter : this._routeToRegExp(filter);

                if (filter.test(fragment)) {
                    fn = _.isFunction(fn) ? fn : this[fn];
                    return fn.apply(this, [fragment, args]) !== false;
                }

                return true;
            }, this);
        },

        /**
         * Override default route function to call before/after filters
         *
         * @param {String} route
         * @param {String} name
         * @param {Function} [callback]
         * @param {Object} [authInfo]
         * @return {*}
         */
        route: function (route, name, callback, authInfo) {
            if (!callback) {
                callback = this[name];
            }

            // Update configuration routes list
            this.routesConf = this.routesConf || [];
            if (-1 === this.routesConf.indexOf(route)) {
                this.routesConf.unshift(route);
            }

            if (!_.isRegExp(route)) {
                route = this._routeToRegExp(route);
            }

            Backbone.history.route(route, _.bind(function (fragment) {
                if (authInfo && authInfo.valid) {
                    var args = this._extractParameters(route, fragment);
                    if (this._filterRoute(this.before, fragment, args, true)) {
                        if (callback) {
                            callback.apply(this, args);
                        }
                        this.trigger.apply(this, ["route:" + name].concat(args));
                        this.trigger("route", name, args);
                        Backbone.history.trigger("route", this, name, args);
                        this._filterRoute(this.after, fragment, args, false);
                    }
                } else if (Backbone.history.fragment) {
                    Backbone.history.history.back();
                }
            }, this));

            return this;
        },

        /**
         * Implement match route function to resolve the matched route for s supplied fragment
         *
         * @return {*}
         */
        matchRoute: function (fragment) {
            var route = null;
            var params = null;
            var matched = false;

            for (var i = 0; i < this.routesConf.length; i++) {
                route = this.routesConf[i] && (_.isRegExp(this.routesConf[i]) ? this.routesConf[i] : this._routeToRegExp(this.routesConf[i]));
                if (route && route.test(fragment || "")) {
                    matched = this.routesConf[i];
                    break;
                }
            }

            if (matched) {
                // Extracts the params using the internal
                // function _extractParameters
                params = this._extractParameters(route, fragment || "");
            }

            return {
                route: matched,
                fragment: fragment,
                params: params
            };
        },

        /**
         * Implement current route function to resolve the matched route for the current fragment
         *
         * @return {*}
         */
        current: function () {
            return this.matchRoute(Backbone.history.fragment);
        }
    });

    return BaseFilteredAppRouter;

});
